import subtract from '@/Assets/Icons/Subtract.png';
import discord from '@/Assets/Icons/discord2.svg';
import galxe from '@/Assets/Icons/galxe.png';
import gitbook from '@/Assets/Icons/gitbook.svg';
import github from '@/Assets/Icons/github.svg';
import twitter from '@/Assets/Icons/twitter2.png';
import mainPageFooter from '@/Assets/images/mainPageFooter.png';
import { ROUTES } from '@/constants/routes.constants';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import Footer from '../Footer';
import './styles.css';

export function FooterLarge() {
  return (
    <div className="mb-3">
      <footer className="main-page--footer">
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 1.5 }}
          viewport={{ once: true, margin: '0% 0% -700px 0%' }}
          className="main-page--footer-bg-container"
        >
          <img src={mainPageFooter} draggable={false} alt="" />
        </motion.div>
        <div className="main-page--footer-content">
          <div className="row">
            <div className="col-12 col-lg-6">
              <h2 className="main-page--footer-heading">
                Multichain made easy
                <br /> All chains, single app
              </h2>
              <div className="main-page--footer-text">
                RetroBridge is a multichain ecosystem and gateway to seamless
                connectivity across EVM and non-EVM chains
              </div>
              <div className="main-page--footer-social">
                <a
                  href="https://twitter.com/retro_bridge"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="main-page--footer-social-item"
                  aria-label="X (Twitter)"
                >
                  <img src={twitter} alt="X (Twitter)" />
                </a>
                <a
                  href="https://discord.gg/retrobridge"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="main-page--footer-social-item"
                  aria-label="Discord"
                >
                  <img src={discord} alt="Discord" />
                </a>
                <a
                  href="https://docs.retrobridge.io/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="main-page--footer-social-item"
                  aria-label="Documentation"
                >
                  <img src={gitbook} alt="Documentation" />
                </a>
                <a
                  href="https://github.com/retro-bridge"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="main-page--footer-social-item"
                  aria-label="GitHub"
                >
                  <img src={github} alt="GitGub" />
                </a>
                <a
                  href="https://app.galxe.com/quest/RetroBridge"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="main-page--footer-social-item"
                  aria-label="Galxe"
                >
                  <img src={galxe} alt="Galxe" />
                </a>
                <a
                  href="https://guild.xyz/retrobridge"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="main-page--footer-social-item"
                  aria-label="Subtract"
                >
                  <img src={subtract} alt="Subtract" />
                </a>
              </div>
            </div>
            <div className="col-12 col-lg-6 d-flex justify-content-lg-end">
              <div className="main-page--footer-nav">
                <div className="main-page--footer-nav-group">
                  <div className="main-page--footer-nav-group-label">
                    Product
                  </div>
                  <Link
                    to={ROUTES.SEND_PAGE}
                    className="main-page--footer-nav-item"
                  >
                    App
                  </Link>
                  <Link
                    to={ROUTES.TESTNET_SEND_PAGE}
                    className="main-page--footer-nav-item"
                  >
                    Testnet App
                  </Link>
                  <Link
                    to={ROUTES.EXPLORER_PAGE}
                    className="main-page--footer-nav-item"
                  >
                    Explorer
                  </Link>
                  <Link
                    to={ROUTES.DEV_API_PAGE}
                    className="main-page--footer-nav-item"
                  >
                    API
                  </Link>
                </div>
                <div className="main-page--footer-nav-group">
                  <div className="main-page--footer-nav-group-label">
                    Phases
                  </div>
                  <Link
                    to={ROUTES.QUESTS_PAGE_PHASES}
                    className="main-page--footer-nav-item"
                  >
                    All Phases
                  </Link>
                  <Link
                    to={ROUTES.QUESTS_PAGE_PHASES}
                    className="main-page--footer-nav-item"
                  >
                    Sunrise Journey
                  </Link>
                  <Link
                    to={ROUTES.QUESTS_PAGE_PHASES}
                    className="main-page--footer-nav-item"
                  >
                    Midday Journey
                  </Link>
                  <Link
                    to={ROUTES.QUESTS_PAGE_ADVENTURES}
                    className="main-page--footer-nav-item"
                  >
                    Retro Adventures
                  </Link>
                </div>
                <div className="main-page--footer-nav-group">
                  <div className="main-page--footer-nav-group-label">Help</div>
                  <Link
                    to="https://docs.retrobridge.io/"
                    className="main-page--footer-nav-item"
                  >
                    Documentation
                  </Link>
                  <Link
                    to={ROUTES.FAQ_PAGE}
                    className="main-page--footer-nav-item"
                  >
                    FAQs
                  </Link>
                  <Link
                    to={ROUTES.PRIVACY_POLICY_PAGE}
                    className="main-page--footer-nav-item"
                  >
                    Terms & Privacy
                  </Link>
                </div>
                <div className="main-page--footer-nav-group d-flex d-lg-none">
                  <div className="main-page--footer-nav-group-label">
                    Audits
                  </div>
                  <Link
                    to={ROUTES.QUANTSTAMP_AUDIT_PAGE}
                    target="_blank"
                    className="main-page--footer-nav-item"
                  >
                    Smart Contracts Audit
                  </Link>
                  <Link
                    to={ROUTES.AUDIT_PAGE}
                    target="_blank"
                    className="main-page--footer-nav-item"
                  >
                    Security Audit
                  </Link>
                  <Link
                    to={ROUTES.MONITORING_AUDIT_PAGE}
                    target="_blank"
                    className="main-page--footer-nav-item"
                  >
                    Security Monitoring
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
      <Footer auditsOnly />
    </div>
  );
}
